module.exports = __webpack_public_path__ + "static/media/img84.7163a4b7.jpg";